module.exports = __webpack_public_path__ + "static/media/LK_User.f503b76d.svg";